import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorMessage } from '@hookform/error-message';
import { Controller, useFormContext } from 'react-hook-form';
import { ErrorMessageDisplay } from '../../../atoms/Input';
import { RadioButton } from './RadioButton';
export const RadioButtonController = props => {
    const { errors } = useFormContext();
    const handleOnChange = (onChange, option) => {
        onChange(option);
        if (props.customOnChange) {
            props.customOnChange(option);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Controller, { rules: props.rules, errors: errors, name: props.name, defaultValue: props.defaultValue, disabled: props.disabled, render: ({ value, onChange, onBlur }) => (_jsx(_Fragment, { children: props.options.map(option => (_jsx(RadioButton, { id: props.name + option, label: option, disabled: props.disabled, checked: value === option, onChange: () => handleOnChange(onChange, option), onClick: props.onClick, onBlur: onBlur }, props.name + option))) })) }), _jsx(ErrorMessage, { errors: errors, name: props.name, render: ({ message }) => _jsx(ErrorMessageDisplay, { id: props.name, message: message }) })] }));
};
